import React, { Component } from 'react';
import { Field,reduxForm, FieldArray } from 'redux-form';
import { Form,Col, Row, Button,Card, CardBody,Input,FormGroup, Label} from 'reactstrap';
import { connect } from 'react-redux';
import {toast } from 'react-toastify';
import DropDownSelect from './DropDownSelect';
import { Preloading } from '../../../components/UI/Preloader/action';
import * as creditLimitModel  from '../Create/action';
class CreateCreditLimitComponent extends Component {

   constructor(props) {
      super(props);
      this.state = {
         variableFiledTypeDropdownOptions:["FORMULA","DROPDOWN","TEXTFIELD"],
         name:"",
         cLMSuccessResponse:[]
      };
   }
   
   componentDidMount() {
      this.props.initialize({
          "dataValues": [{}],
          })
  }

  componentDidUpdate(prevProps) {
   if (this.props.creditLimitModelResponse !== prevProps.creditLimitModelResponse) {
      this.props.preloading(false);
          toast.success(<div>
            <i className="fa fa-success"></i>&nbsp;Credit limit template added !  
         </div>);
         
   }
   }

  setModelName=(event)=>{
   this.setState({
      name:event.target.value
   })  
   
  }
  
  handleFormSubmit = (event)=>{
   const { reset } = this.props
   event.preventDefault()
   let comboLength = (event.target.elements.length-2) / 3
   if (comboLength === 0) {
      toast.error(<div>
         <i className="fa fa-warning"></i>&nbsp;Empty model can&#39;t be submitted !
      </div>);
   }
   else{
      let request = this.createRequest(event.target.elements)
      if(request){
         this.props.addCreditLimitModel(request)
         this.props.preloading(true);
         reset();
      }
      
   }
  }

  createRequest = (elems) => {
   let creditLimitModelObj = {}
   creditLimitModelObj.name = this.state.name;
   let dataValues = []
   let comboLength = (elems.length-3) / 4
   for(let i = 0; i< comboLength; i++) {
      if(elems[`dataValues[${i}].displayName`].value){
         dataValues[i] = {
            displayName : elems[`dataValues[${i}].displayName`].value,
            masterKey : elems[`dataValues[${i}].masterKey`].value,
            type : elems[`dataValues[${i}].type`].value,
            value : elems[`dataValues[${i}].value`].value
        }
      }
      else{
         toast.error(<div>
            <i className="fa fa-warning"></i>&nbsp;Field Name Empty !
         </div>);
      }
   }
   var valueArr = dataValues.map(function(item){ return item.displayName });
   var isDuplicate = valueArr.some(function(item, idx){ 
    return valueArr.indexOf(item) != idx 
   }); 
   if(!isDuplicate){
      creditLimitModelObj.dataValues=dataValues;
      return {creditLimitModelObj}
   } 
   else{
      toast.error(<div>
         <i className="fa fa-warning"></i>&nbsp;Duplicate name !
      </div>);
      return false
   }
   }



   render() {
        return(
         <Col>
            <div className="d-flex justify-content-between align-items-center mb-3">
               <h4 className="mb-0">Create Credit Limit Model</h4>
            </div>
            <Card>
               <CardBody>
                  <Form onSubmit={(e) => this.handleFormSubmit(e)}>
                     <Row>
                        <div className='col-sm-3'><Label className="ml-3">Model Name:<span className="text-danger">*</span></Label></div>
                           <Field className="form-group ml-3 p-2 radius-5 border risk-grade-input" component="input" name="modelName" type="text" placeholder="Model Name" onChange={this.setModelName} required/>
                     </Row>
                     <Row className="mt-3">   
                        <Col sm='5' className="ml-3"><label>Name<span className="text-danger">*</span></label></Col>
                        <Col sm='5'><label>Master Key</label></Col>
                        <Col sm='5'><label>Field Type</label></Col>
                        <Col sm='5'><label>Field Value</label></Col>
                     </Row>
                        <FieldArray name="dataValues" component={renderMembers} dropDownOptions={this.state.variableFiledTypeDropdownOptions} required/> 
                     <div>
                        <button type="submit" className="btn btn-info">Submit</button>
                     </div>   
                  </Form> 
               </CardBody>
            </Card>
         </Col>
         );   
     }
   }
const mapStateToProps = (state) => ({
   creditLimitModelResponse:state.creditLimitModelResponse.addCreditLimitModelResponse
});

const mapDispatchToProps = (dispatch) => ({
   addCreditLimitModel : (data) => dispatch(creditLimitModel.addCreditLimitModel(data)),
   preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default reduxForm({
   form: 'CreateCreditLimitComponent'
})(connect(mapStateToProps, mapDispatchToProps)(CreateCreditLimitComponent))


const renderMembers = ({ fields, dropDownOptions ,meta: { error, submitFailed } }) => (
   <ul>
       {fields.map((member, index) => (
           <li key={index}>
            <Row className="d-flex align-items-center mb-3">    
               <Col sm="5" className="px-2">
                     <Field name={`${member}.displayName`} className="p-2 w-100 radius-5 border risk-grade-input" type="text" placeholder="Name" component="input" required/>
               </Col>
               {/* <Col sm="5" className="px-2">
                  <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                     <Input name={`${member}.elementValue`} type="text" id={`elementName${index}`}  />
                  </FormGroup> 
               </Col> */}
               <Col sm="5" className="px-2">
                  <Field name={`${member}.masterKey`} className="p-2 w-100 radius-5 border risk-grade-input" type="text" placeholder="Master Key" component="input"/>
               </Col>      
               <Col sm="5" className="px-2">
                  <Field
                  name={`${member}.type`}
                  type="text"
                  component={DropDownSelect}
                  label="State"
                  data={dropDownOptions}
                  />
               </Col>
               <Col sm="5" className="px-2">
                     <Field name={`${member}.value`} className="p-2 w-100 radius-5 border risk-grade-input" type="textarea" placeholder="Value" component="textarea"/>
               </Col> 
               <Col sm="2" className="px-2 text-right"><a onClick={() => fields.remove(index)}><i className="icon-close text-danger pointer"></i></a> </Col>
            </Row> 
            <br/>
           </li>
           
       ))}
         <Row>
            <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-4 pt-0" color="link" onClick={() => fields.push({})}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
         </Row>
         
   </ul>
)